import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserSiginService } from './user-sigin.service';

@Injectable({
  providedIn: 'root'
})
export class UserAuthGuard implements CanActivate {
  constructor(private userValid: UserSiginService, private router: Router) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.userValid.isCheckUserAuthntication().then((isValid) => {
      console.log("user data status from service ====", isValid);
      if (isValid) {
        return true;
      } else {
        this.router.navigate(['']);
        return false;
      }
    });

  }

}
